import Vue from 'vue';
import { classToPositiveNumber } from './../../mixins/classToPositiveNumber';
import BigNumber from 'bignumber.js';
export default Vue.extend({
    name: 'finRes',
    props: {
        isBottom: {
            type: Boolean,
            required: false,
            default: false
        },
        blur: {
            type: Boolean,
            required: false,
            default: false
        },
        showAdditionalText: {
            type: Boolean,
            required: false,
            default: false
        },
        showDollarSign: {
            type: Boolean,
            required: false,
            default: true
        },
        size: {
            type: String,
            required: false,
            default: 'small'
        },
        value: {
            type: BigNumber,
            required: true,
            default: null
        },
        percent: {
            type: Object,
            required: true,
            default: null
        },
        showPercent: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    mixins: [classToPositiveNumber],
    computed: {
        appearPercent() {
            return this.showPercent && !this.percent.isEqualTo(0);
        },
        dollarSign() {
            return this.showDollarSign ? '$' : '';
        }
    },
    methods: {
        changeDollarSignAppearance() {
            this.$emit('change-dollar-sign-appearance');
        },
        prependSign(value) {
            let result = '';
            if (Number(value) > 0)
                result = '+';
            return result;
        }
    }
});
